module.exports = __webpack_public_path__ + "static/media/sea-eagles-silhouette.dcb332ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/sea-eagles-silhouette.svg
// module id = 1335
// module chunks = 0